import type { LogoProps, TenantLogo } from '../../contract.ts';
import { cn } from '@/utils/utils.ts';

const Logo: TenantLogo = ({ width, height, withText = true, className, nav }: LogoProps) => {
  const { isExpanded = true, isHovered = false } = nav ?? {};
  const showText = withText && (isExpanded || isHovered);
  const svgHeight = height ?? '80';
  const svgWidth = showText ? width : Math.min(Number(width), 80);

  if (showText) {
    return (
      <svg
        width={svgWidth}
        height={svgHeight}
        className={cn(!isExpanded || (!isHovered && 'pl-1'), className)}
        viewBox="0 0 1080 279"
        fill="none"
      >
        <g>
          <path
            d="M0 77.6699H50.2327V98.1972C61.6829 88.5807 72.0248 81.9232 81.2589 78.2247C90.6158 74.4027 100.158 72.4917 109.884 72.4917C129.829 72.4917 146.758 79.4574 160.671 93.3888C172.367 105.224 178.215 122.731 178.215 145.909V278.874H128.352V190.662C128.352 166.621 127.244 150.656 125.028 142.765C122.935 134.875 119.179 128.896 113.762 124.827C108.468 120.635 101.881 118.54 94.0017 118.54C83.7829 118.54 74.9797 121.991 67.5925 128.896C60.3286 135.676 55.2805 145.108 52.4488 157.19C50.9714 163.477 50.2327 177.101 50.2327 198.06V278.874H0V77.6699Z"
            fill="black"
          />
          <path
            d="M476.977 0H527.397V160.705L601.637 77.6707H664.798L578.366 174.204L675.322 278.875H612.716L527.397 186.225V278.875H476.977V0Z"
            fill="black"
          />
          <path
            d="M745.271 3.51367H795.502V77.6707H825.419V121.129H795.502V278.875H745.271V121.129H719.414V77.6707H745.271V3.51367Z"
            fill="black"
          />
          <path
            d="M973.44 67.4395C992.4 67.4395 1010.19 72.1863 1026.81 81.6794C1043.55 91.1724 1056.61 104.056 1065.96 120.33C1075.32 136.604 1080 154.172 1080 173.035C1080 192.021 1075.26 209.774 1065.78 226.295C1056.42 242.815 1043.62 255.76 1027.37 265.13C1011.11 274.377 993.202 279 973.626 279C944.815 279 920.19 268.767 899.752 248.302C879.438 227.713 869.279 202.747 869.279 173.405C869.279 141.966 880.791 115.768 903.816 94.8094C924.007 76.5628 947.214 67.4395 973.44 67.4395ZM974.178 114.967C958.544 114.967 945.492 120.453 935.026 131.426C924.684 142.275 919.514 156.206 919.514 173.22C919.514 190.727 924.623 204.905 934.843 215.754C945.184 226.603 958.236 232.028 973.995 232.028C989.754 232.028 1002.87 226.541 1013.33 215.569C1023.8 204.596 1029.03 190.48 1029.03 173.22C1029.03 155.96 1023.86 141.966 1013.52 131.241C1003.3 120.391 990.184 114.967 974.178 114.967Z"
            fill="black"
          />
          <path
            d="M433.026 173.493C433.026 231.763 385.778 279 327.496 279C269.213 279 221.966 231.763 221.966 173.493C221.966 115.223 269.213 67.9863 327.496 67.9863C385.778 67.9863 433.026 115.223 433.026 173.493ZM237.64 173.493C237.64 223.108 277.87 263.329 327.496 263.329C377.121 263.329 417.351 223.108 417.351 173.493C417.351 123.878 377.121 83.6571 327.496 83.6571C277.87 83.6571 237.64 123.878 237.64 173.493Z"
            fill="black"
          />
          <path
            d="M275.261 225.716C268.402 218.858 262.96 210.716 259.248 201.756C255.536 192.796 253.625 183.192 253.625 173.493C253.625 163.794 255.536 154.19 259.248 145.23C262.96 136.27 268.402 128.128 275.261 121.27C282.121 114.412 290.264 108.972 299.227 105.26C308.189 101.549 317.795 99.6382 327.496 99.6382C337.196 99.6382 346.803 101.549 355.765 105.26C364.727 108.972 372.871 114.412 379.732 121.27L327.496 173.493L275.261 225.716Z"
            fill="black"
          />
          <path
            d="M297.648 203.335C289.732 195.421 285.284 184.686 285.284 173.493C285.284 162.301 289.732 151.566 297.648 143.652C305.564 135.737 316.301 131.291 327.496 131.291C338.691 131.291 349.43 135.737 357.346 143.652L327.496 173.493L297.648 203.335Z"
            fill="#FD5200"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg
      width={svgWidth}
      height={svgHeight}
      className={className}
      viewBox="0 0 280 280"
      fill="none"
    >
      <g>
        <path
          d="M280 140C280 217.32 217.32 280 140 280C62.68 280 0 217.32 0 140C0 62.68 62.68 0 140 0C217.32 0 280 62.68 280 140ZM20.794 140C20.794 205.836 74.1643 259.206 140 259.206C205.836 259.206 259.206 205.836 259.206 140C259.206 74.1643 205.836 20.794 140 20.794C74.1643 20.794 20.794 74.1643 20.794 140Z"
          fill="black"
        />
        <path
          d="M70.7034 209.297C61.6034 200.197 54.3847 189.393 49.4596 177.503C44.5349 165.613 42 152.87 42 140C42 127.131 44.5349 114.387 49.46 102.497C54.3847 90.6071 61.6034 79.8037 70.7034 70.7033C79.8038 61.6033 90.6072 54.3846 102.497 49.4599C114.387 44.5348 127.131 42 140 42C152.869 42 165.613 44.5348 177.503 49.4599C189.393 54.3846 200.196 61.6033 209.297 70.7037L140 140L70.7034 209.297Z"
          fill="black"
        />
        <path
          d="M100.402 179.598C89.9 169.096 84 154.852 84 140C84 125.148 89.9 110.904 100.402 100.402C110.904 89.9 125.148 84 140 84C154.852 84 169.096 89.9 179.598 100.402L140 140L100.402 179.598Z"
          fill="#FD5200"
        />
      </g>
    </svg>
  );
};

export default Logo;
